import React from 'react';
import Button from '@mui/material/Button'
function ListSingleUser() {
  return <div>
      <Button>List single user</Button>
  </div>;
}

export default ListSingleUser;
